// extracted by mini-css-extract-plugin
export default {"radioGroup":"edit-training-program-department_radioGroup__cY9EE"};